import React, { useEffect } from "react";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";
import { actions as ListAction } from "../ListView/redux/slice";
import { actions, reducer, sliceKey } from "./redux/slice";

import { useDispatch, useSelector } from "react-redux";
import { selectQuery } from "../ListView/redux/selector";
import { selectInstructorList } from "./redux/selector";

import { useCalenderSaga } from "./redux/saga";

import moment from "moment";
import InstructorsCalender from "./components/InstructorsCalender";
interface Props {}

const CalenderInstructorMonth = () => {
  useInjectReducer({ key: sliceKey, reducer });
  useInjectSaga({ key: sliceKey, saga: useCalenderSaga });

  const dispatch = useDispatch();
  const list = useSelector(selectInstructorList);
  const { date, q, treatmentId, mode } = useSelector(selectQuery);

  const setPageQuery = (name: string, value: any) => {
    dispatch(ListAction.setQuery({ name, value }));
  };
  useEffect(() => {
    if (treatmentId) {
      dispatch(actions.getListInstructor());
    }

    return () => {};
  }, [date, q, treatmentId, mode]);

  useEffect(() => {
    setPageQuery("date", moment().startOf("month").format("YYYY-MM-DD"));
    setPageQuery("mode", "monthopp");
    return () => {};
  }, []);

  return (
    <InstructorsCalender
      loading={list.loading}
      data={list.items}
      dateChange={(data) => {
        setPageQuery("date", moment(data).format("YYYY-MM-DD"));
      }}
    />
  );
};
export default CalenderInstructorMonth;
